// File: src/components/modal/TicketStatusModal.tsx

import {
  Box,
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  Modal,
  Select
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { makeToasterErrorHandler } from "../../common/http/makeToasterErrorHandler";
import { TicketInterface } from "../../common/interfaces";
import { usePageToast } from "../../hooks/usePageToast";
import api from "../../services/api";
import {
  TypeTicketStatus,
  TypeTicketStatusLabel
} from "../enum/typeTicketStatusEnum";
import PageToaster from "../toaster/PageToaster";

interface TicketStatusModalProps {
  open: boolean;
  onClose: () => void;
  /** Avisa a lista para recarregar depois de trocar o status. */
  onChanged: () => void;
  ticket: TicketInterface | null;
}

const TicketStatusModal: React.FC<TicketStatusModalProps> = ({
  open,
  onClose,
  onChanged,
  ticket
}) => {
  const [status, setStatus] = useState<TypeTicketStatus>(
    TypeTicketStatus.OPEN
  );

  const containerId = "toaster-ticket-status-modal";
  const { autoSuccess, autoError } = usePageToast(containerId, true);
  const handleHttpError = makeToasterErrorHandler(autoError);

  useEffect(() => {
    if (ticket) setStatus(ticket.ticket_status ?? TypeTicketStatus.OPEN);
  }, [ticket]);

  const handleConfirm = async () => {
    if (!ticket?.ticket_id) return;
    try {
      await api.put(`/ticket/${ticket.ticket_id}`, { ticket_status: status });
      autoSuccess("Status do ticket atualizado!");
      onChanged();
      onClose();
    } catch (error) {
      console.error("Erro ao atualizar status do ticket:", error);
      handleHttpError(error);
    }
  };

  return (
    <>
      <PageToaster containerId={containerId} />
      <Modal open={open} onClose={onClose}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            bgcolor: "background.paper",
            border: "1px solid var(--border-strong)",
            p: 3,
            borderRadius: 2,
            boxShadow: 3,
            width: 360
          }}
        >
          <h2>Status do Ticket</h2>
          {ticket && (
            <p style={{ color: "var(--text-muted)", marginTop: -8 }}>
              {ticket.ticket_title}
            </p>
          )}

          <FormControl fullWidth margin="normal">
            <InputLabel>Status</InputLabel>
            <Select
              value={status}
              label="Status"
              onChange={(e) => setStatus(e.target.value as TypeTicketStatus)}
            >
              {(Object.values(TypeTicketStatus) as TypeTicketStatus[])
                .filter((s) => s !== TypeTicketStatus.NONE)
                .map((s) => (
                  <MenuItem key={s} value={s}>
                    {TypeTicketStatusLabel[s]}
                  </MenuItem>
                ))}
            </Select>
          </FormControl>

          <Box sx={{ mt: 3, textAlign: "right" }}>
            <Button onClick={onClose} sx={{ mr: 1 }}>
              Cancelar
            </Button>
            <Button variant="contained" onClick={handleConfirm}>
              Salvar
            </Button>
          </Box>
        </Box>
      </Modal>
    </>
  );
};

export default TicketStatusModal;
